import { z } from "zod";
import { apiClient } from "../client";
import { userSchema } from "./schemas";
import type { User, SetPermissionsRequest, OnboardUserRequest } from "./types";

export async function getUsers(): Promise<User[]> {
  const response = await apiClient.get("users", {}).json<User[]>();
  return z.array(userSchema).parse(response);
}

export async function setUserPermissions(
  entraObjectId: string,
  data: SetPermissionsRequest
): Promise<void> {
  await apiClient.put(`users/${entraObjectId}/permissions`, { json: data });
}

export async function onboardUser(data: OnboardUserRequest): Promise<User> {
  const response = await apiClient
    .post("users/onboard", { json: data })
    .json<User>();
  return userSchema.parse(response);
}

export async function deleteUser(id: number): Promise<void> {
  await apiClient.delete(`users/${id}`, {});
}
